import Cookies from 'js-cookie'

const LOCALE_SET = 'LOCALE_SET';

const locale = 'en';
const locales = {
    'en': 'English'
    ,'sv': 'Svenska'
};
export const state = {
    locale: Cookies.get('dcpn_locale') || locale,
    locales: locales
};

export const getters = {
    locale: state => state.locale,
    locales: state => state.locales,
    showAuth: state => state.auth
};

export const mutations = {
    [LOCALE_SET] (state, { locale }) {
        state.locale = locale
    }
};

export const actions = {
    setLocale ({ commit }, { locale }) {
        commit(LOCALE_SET, { locale });
        Cookies.set('dcpn_locale', locale, { expires: 365 })
    }
};
